import { render } from "./TabNavContent.vue?vue&type=template&id=90752756&scoped=true&ts=true"
import script from "./TabNavContent.vue?vue&type=script&lang=ts"
export * from "./TabNavContent.vue?vue&type=script&lang=ts"

import "./TabNavContent.vue?vue&type=style&index=0&id=90752756&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90752756"]])

export default __exports__